// extracted by css-extract-rspack-plugin
export default {"container":"TrailingBadge-module__container__LWcOE","label":"TrailingBadge-module__label__C7wZv","title":"TrailingBadge-module__title__WfDsT"};